import { render, staticRenderFns } from "./RaceHeader.vue?vue&type=template&id=5fd7c2a3&"
import script from "./RaceHeader.vue?vue&type=script&lang=js&"
export * from "./RaceHeader.vue?vue&type=script&lang=js&"
import style0 from "./RaceHeader.vue?vue&type=style&index=0&id=5fd7c2a3&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports